import React from 'react';
import { LocalNavigation } from '@acast/decibel';
import OverviewItem from '../../app/navigation/OverviewItem';
import SelectShowItem from '../../app/navigation/SelectShowItem';
import InsightsItem from '../../app/navigation/InsightsItem';

export default function Navigation() {
  return (
    <LocalNavigation>
      <LocalNavigation.Column>
        <OverviewItem selected />
        <SelectShowItem />
      </LocalNavigation.Column>
      <LocalNavigation.Column align="right" stretch>
        <InsightsItem />
      </LocalNavigation.Column>
    </LocalNavigation>
  );
}
